import Vue from 'vue'
import App from './App.vue'
import gtm from 'vue-gtm'

Vue.config.productionTip = false

Vue.use(gtm, {
  id: "GTM-MN9QHTQ",
  debug: true
});

new Vue({
  render: h => h(App),
}).$mount('#app')
